import React from "react";
import ResultYearSection from "./result-year-section/ResultYearSection";
import ResultTopperStories from "./result-topper-stories/ResultTopperStories";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import LiveChat from "../section-component/live-chat/LiveChat";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const ResultIndex = () => {
    return (
        <>
        
 
        <ResultYearSection />
        <ResultTopperStories />
        
        
        </>
    );
};
export default ResultIndex;